/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style8 = require("antd/lib/tooltip/style");

var _tooltip = require("antd/lib/tooltip");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _style9 = require("antd/lib/card/style");

var _card = require("antd/lib/card");

var _card2 = _interopRequireDefault(_card);

var _style10 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _style11 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style12 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _style13 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _style14 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _tpl = require("tpl");

var _tpl2 = _interopRequireDefault(_tpl);

require("./index.less");

var _reactRouter = require("react-router");

var _tool = require("util/tool");

var _config = require("util/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item,
    TextArea = _input2.default.TextArea,
    ButtonGroup = _button2.default.Group;

var _ref = (0, _jsx3.default)(_input2.default, {
  placeholder: "\u90E8\u4EF6\u540D\u79F0",
  maxLength: "20"
});

var _ref2 = (0, _jsx3.default)(_input2.default, {
  placeholder: "\u90E8\u4EF6\u4EE3\u7801",
  maxLength: "20"
});

var _ref3 = (0, _jsx3.default)(TextArea, {
  placeholder: "\u90E8\u4EF6\u63CF\u8FF0",
  maxLength: "30"
});

var _ref4 = (0, _jsx3.default)("p", {
  className: "newCenter"
}, void 0, "+ \u65B0\u589E\u90E8\u4EF6");

var _ref5 = (0, _jsx3.default)("img", {
  src: "https://p1.music.126.net/GdgXYT-c1JANL3cJz7VH-A==/3404088000556407.jpg?param=200y200"
});

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this2.state = {
      visible: false,
      partsInfo: [],
      default: {
        partName: "",
        partCode: "",
        remark: ""
      },
      // true 新增 false 编辑
      status: true,
      // 当前操作ID
      nowId: ""
    };
    return _this2;
  }

  (0, _createClass3.default)(Main, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      // 请求所有部件
      (0, _tool.http)(_config.apiJson.getAllPart).then(function (req) {
        _this3.setState({
          partsInfo: req,
          default: {
            partName: "",
            partCode: "",
            remark: ""
          }
        });
      });
    }
  }, {
    key: "openNew",
    value: function openNew() {
      // 重置默认
      this.setState({
        visible: true,
        default: {
          partName: "",
          partCode: "",
          remark: ""
        },
        status: true
      });
    }
  }, {
    key: "handleOk",
    value: function handleOk() {
      var _this4 = this;

      this.props.form.validateFields(function (err, values) {
        if (!err) {
          // values
          if (values.partCode === values.partName) {
            _message2.default.error('部件名称与部件代码不能一致');
            return false;
          }
          (0, _tool.http)(_this4.state.status ? _config.apiJson.insertPar : _config.apiJson.updatePart, _this4.status ? values : (0, _extends3.default)({}, values, {
            id: _this4.state.nowId
          })).then(function (req) {
            req ? function (_this) {
              _message2.default.success("" + (_this.state.status ? '添加' : '编辑成功'));
              _this.init();
            }(_this4) : '';
          });
          _this4.setState({
            visible: false
          });
          _this4.props.form.resetFields();
        } else {}
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.props.form.resetFields();
      this.setState({
        visible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 }
      };
      var getFieldDecorator = this.props.form.getFieldDecorator;
      // const _this = this

      return (
        // 返回卡片demo，循环可操作
        (0, _jsx3.default)("div", {
          style: { overflow: "hidden" }
        }, void 0, (0, _jsx3.default)(_modal2.default, {
          title: this.state.status ? '新增部件' : '编辑部件',
          visible: this.state.visible,
          onOk: this.handleOk.bind(this),
          onCancel: this.handleCancel.bind(this)
        }, void 0, (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_form2.default, {}, void 0, _react2.default.createElement(
          FormItem,
          (0, _extends3.default)({}, formItemLayout, { label: "\u90E8\u4EF6\u540D\u79F0" }),
          getFieldDecorator("partName", {
            rules: [{
              required: true,
              message: "请输入部件名称"
            }],
            initialValue: this.state.default.partName
          })(_ref)
        ), _react2.default.createElement(
          FormItem,
          (0, _extends3.default)({}, formItemLayout, { label: "\u90E8\u4EF6\u4EE3\u7801" }),
          getFieldDecorator("partCode", {
            rules: [{
              required: true,
              message: "请输入部件代码"
            }],
            initialValue: this.state.default.partCode
          })(_ref2)
        ), _react2.default.createElement(
          FormItem,
          (0, _extends3.default)({}, formItemLayout, { label: "\u90E8\u4EF6\u63CF\u8FF0" }),
          getFieldDecorator("remark", {
            rules: [{
              required: false,
              message: "请输入部件描述"
            }],
            initialValue: this.state.default.remark
          })(_ref3)
        )))), (0, _jsx3.default)(_button2.default, {
          className: "call",
          type: "primary",
          onClick: function onClick() {
            history.go(-1);
          }
        }, void 0, "\u8FD4\u56DE"), (0, _jsx3.default)(_card2.default, {
          onClick: this.openNew.bind(this),
          className: "new",
          style: { width: 300, float: "left", marginLeft: "10px" }
        }, void 0, _ref4), function (_this) {
          var Vnode = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            var _loop = function _loop() {
              var ins = _step.value;

              Vnode.push((0, _jsx3.default)(_card2.default, {
                className: "partsCard",
                style: { width: 300, float: "left", marginLeft: "10px" }
              }, ins.id, _ref5, (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_tooltip2.default, {
                placement: "topLeft",
                title: ins.partName
              }, void 0, (0, _jsx3.default)("p", {}, void 0, ins.partName)), (0, _jsx3.default)(_tooltip2.default, {
                placement: "topLeft",
                title: ins.partCode
              }, void 0, (0, _jsx3.default)("p", {}, void 0, "\u90E8\u4EF6\u4EE3\u7801\uFF1A", ins.partCode)), (0, _jsx3.default)(_tooltip2.default, {
                placement: "topLeft",
                title: ins.remark
              }, void 0, (0, _jsx3.default)("p", {
                style: { height: 33, width: 170 }
              }, void 0, ins.remark))), (0, _jsx3.default)(ButtonGroup, {
                style: { width: "100%", borderTop: "1px solid #dcdcdc" }
              }, void 0, (0, _jsx3.default)(_button2.default, {
                onClick: function onClick(es) {
                  _modal2.default.confirm({
                    title: "\u786E\u8BA4\u5220\u9664" + ins.partName + "\u90E8\u4EF6\uFF1F",
                    okText: "确认",
                    cancelText: "取消",
                    onOk: function onOk() {
                      (0, _tool.http)(_config.apiJson.delPart, { id: ins.id }).then(function (req) {
                        req ? _this.init() : "";
                      });
                    }
                  });
                  return;
                },
                style: {
                  width: "50%",
                  border: "0px",
                  borderRight: "1px solid #dcdcdc"
                }
              }, void 0, "\u5220\u9664"), (0, _jsx3.default)(_button2.default, {
                onClick: function onClick(es) {
                  // 编辑内容
                  _this.setState({
                    visible: true,
                    default: {
                      partName: ins.partName,
                      partCode: ins.partCode,
                      remark: ins.remark
                    },
                    status: false,
                    nowId: ins.id
                  });
                  _this.props.form.resetFields();

                  // 赋值
                },
                style: {
                  width: "50%",
                  border: "0px",
                  borderLeft: "1px solid #dcdcdc"
                }
              }, void 0, "\u7F16\u8F91"))));
            };

            for (var _iterator = (0, _getIterator3.default)(_this.state.partsInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return Vnode;
        }(this))
      );
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  component: _form2.default.create()((0, _reactRouter.withRouter)(Main)) // 接收数据的组件入口
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/parts/index.jsx
// module id = 1541
// module chunks = 0